/* packages/core/src/components/chat/effects/EffectContainer.jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import { getEffectRenderer } from './EffectRegistry';

const EffectContainer = ({ effects }) => {
  if (!effects || effects.length === 0) return null;

  const renderableEffects = effects.map((effectItem, index) => {
    const event = effectItem.data;
    // Look for resource_type OR effect_key
    const rendererKey = event.resource_type || event.effect_key;
    const Renderer = getEffectRenderer(rendererKey);
    
    if (!Renderer) return null;
    
    return <Renderer key={effectItem.key || index} event={event} />;
  }).filter(Boolean);

  if (renderableEffects.length === 0) return null;

  return (
    <Box sx={{ mt: 1, mb: 1, width: '100%' }}>
      <Stack direction="column" spacing={1} alignItems="flex-start">
        {renderableEffects}
      </Stack>
    </Box>
  );
};

EffectContainer.propTypes = {
  effects: PropTypes.array,
};

export default React.memo(EffectContainer);